import { DEFAULT_SELECT_PAGE_SIZE } from '@shared/constants/selectPagination';

import { ShadcnQuerySelectParams } from '@shadcn-features/query-select';

type GetUrlPaginationParams = {
    paramType: string;
    paramCode: string;
    defaultIds?: string[];
    params?: ShadcnQuerySelectParams;
    enabled?: boolean;
};

const getUrlSelectServicePagination = ({
    paramType,
    paramCode,
    defaultIds,
    ...props
}: GetUrlPaginationParams) => {
    const params = {
        ...(paramType !== 'flow' && paramType !== 'event' && paramType !== 'idp'
            ? { code: paramCode }
            : {}),
        ...props.params,
        includeValues: defaultIds,
    };
    const url =
        paramType === 'flow'
            ? `flow/Dictionaries/GetPaginated/${paramCode}`
            : paramType === 'event'
              ? `event/EventDictionaries/${paramCode}/paginated`
              : paramType === 'idp'
                ? `idp/Dictionaries/paginated/${paramCode}`
                : `${paramType}/Dictionaries/GetPaginated`;

    return {
        enabled: props.enabled,
        url,
        params: (page = 1) => ({
            ...params,
            page,
            size: DEFAULT_SELECT_PAGE_SIZE,
        }),
    };
};

export { getUrlSelectServicePagination };
